const kashika3Options = [
  
    {
        menuName: "カメラマップ",
        activateAccordion: true,
        options: [

            {
                label: "カメラマップ",
                type: "marker",
                id: "vis_87",
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_SPOT_87,
            },
        ]
    },

];


export  {
    kashika3Options
};
